import { errorMsg } from '../constants/messages';

const ServicePageFAQFormData = [
  {
    title: 'Service Page FAQ Details',
    name: 'question',
    label: 'Question',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Question', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'answer',
    label: 'Answer',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Answer' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'serviceCategory',
    label: 'Service Category',
    fieldType: {
      name: 'select',
      options: [],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Service Category', allowAddRecordClick: true, columnType: 'displayName' },
    isTableHeader: true,
    isAccordian: false,
    readonly: false,
  },
  {
    name: 'sortOrder',
    label: 'Sort Order',
    fieldType: {
      name: 'number',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Sort Order', enableSort: true },
    isTableHeader: true,
    isAccordian: false,
    default: 0,
  },
  {
    name: 'isActive',
    label: 'Is Active',
    fieldType: {
      name: 'select',
      options: [
        { id: '1', value: true, name: 'Yes' },
        { id: '2', value: false, name: 'No' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Is Active' },
    isTableHeader: true,
    isAccordian: false,
    default: true,
  },
];

export { ServicePageFAQFormData };
